import React, { Component } from 'react'

import Repository from '../../felles/repository'
import _ from 'lodash'
import { resolve } from '../../dependencies'

import NkaButton from 'nka-button'
import NkaTextarea from 'nka-text-area'
import NkaCheckbox from 'nka-checkbox'

import './sms.css'
import 'nka-button/dist/style.css'
import 'nka-text-area/dist/style.css'
import 'nka-checkbox/dist/style.css'

export default class SmsContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            smsMal: '',
            brukerEksaktTidspunkt: undefined
        }

        this._endretSmsMal = this._endretSmsMal.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this._settBrukavtidspunkt = this._settBrukavtidspunkt.bind(this)
        this._dataMotatt = this._dataMotatt.bind(this)
    }

    componentDidMount() {
        Promise.all(
            [
                resolve(Repository).hentSmsMalForKunde(),
                resolve(Repository).hentSmsTidspunktInnstillingForKunde()
            ]).then(this._dataMotatt)
        
    }

    _dataMotatt(data) {
        
        let smsMal = data[0]
        let tidsInnstilling = data[1]
        
        this.setState({
            smsMal: smsMal ? smsMal : '',
            brukerEksaktTidspunkt: tidsInnstilling === '1' 
        })
    }

    _endretSmsMal(event) {
        this.setState({
            smsMal: event.target.value
        })
    }

    handleSubmit(event) {
        event.preventDefault()

        let smsInstilling = [
            {
                Navn: 'SmsMal',
                Verdi: this.state.smsMal
            },
            {
                Navn: 'BrukEksaktTidspunktISMS',
                Verdi: this.state.brukerEksaktTidspunkt ? '1' : '0'
            }
        ]

        _.forEach(smsInstilling, i => this._lagreInnstiller(i))
    }

    _lagreInnstiller(smsInstilling) {
        resolve(Repository).lagreInnstillingForKunde(smsInstilling)
    }

    _settBrukavtidspunkt(event) {
        this.setState({
            brukerEksaktTidspunkt: event.target.checked
        })
    }

    render() {
        return (
            <div className="listeContainer">
                <h2>Oppsett av mal for utsendelse av sms</h2>
                <p>
                    Flettefelt tilgjengelig: &lt;#Maalernummer#&gt;, &lt;#Maaleradresse#&gt;,
                    &lt;#Dato#&gt; og &lt;#Tidsrom#&gt;
                </p>

                <NkaTextarea
                    className="smsMal"
                    name="smsmal"
                    id=""
                    rows="10"
                    value={this.state.smsMal}
                    onChange={this._endretSmsMal}
                />

                <NkaCheckbox checked={this.state.brukerEksaktTidspunkt} onChange={this._settBrukavtidspunkt} className="smsMal">
                    Bruk eksakt tidspunkt i SMS, ikke tidsrom
                </NkaCheckbox>

                <NkaButton buttontype="primary" onClick={this.handleSubmit}>
                    Lagre
                </NkaButton>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/innstillinger/sms/smsContainer.jsx